import * as React from "react";
import styles from "./no-data-view.module.scss";

const NoDataView = (): React.JSX.Element => (
  <div className={styles.noDataView}>No Data Available</div>
);
export default NoDataView;
